var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconDiscover = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 1.82A8.18 8.18 0 1 1 1.82 10 8.18 8.18 0 0 1 10 1.82M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0",
  className: "icon-discover_svg__cls-1"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 9a1 1 0 1 0 1 1 1 1 0 0 0-1-1m4.88-3.63a.5.5 0 0 1 0 .42l-2.58 5.54a2 2 0 0 1-1 1l-5.51 2.55a.51.51 0 0 1-.67-.67L7.7 8.67a2 2 0 0 1 1-1l5.54-2.58a.52.52 0 0 1 .64.28",
  className: "icon-discover_svg__cls-1"
})));
export default SvgIconDiscover;